import { P, hasAnyPermission, hasPermission } from "../utils/permissions";

export function getPermissionHomePath(permissions = []) {
  if (hasPermission(permissions, P.ORDERS_READ_ALL)) return "/orders";
  if (hasPermission(permissions, P.ORDERS_READ_VA)) return "/orders";
  if (hasPermission(permissions, P.ORDERS_READ_ASSIGNED)) return "/distributor";
  if (
    hasAnyPermission(
      permissions,
      P.ORDERS_READ_OWN,
      P.AUDIOLOGIST_ORDER_CREATE
    )
  ) {
    return "/audiologist";
  }
  return "/access-denied";
}
